<template>
    <div>
      <div class="tip_b f-cb">
        <img class="shield float-left" src="./shield.png"/>
        <p class="tip_p float-right">为了您的账户安全<br>请及时绑定手机</p>
      </div>
      <input type="text" ref="phone_ipt" placeholder="请输入您的手机号码" class="phone_ipt" v-model="phone_num"/>
      <div class="verify_code_b f-cb">
        <input type="text" placeholder="请输入验证码" class="verify_code float-left" v-model="verify_code"/>
        <div class="verify_code_btn float-right" @click="send_code()">发送验证码<span v-show="!apply_code">({{code_timing}})</span></div>
      </div>
      <div class="submit_btn" @click="submitfun()">提交</div>
      <div v-show="isDialogShow" class="msg_pop">{{error}}</div>
    </div>
</template>

<script>
    import "@/asset/css/account.css";
    export default {
        name: "bindphone",
        data(){
          return{
            error:'',
            isDialogShow:false,
            phone_num:'',
            verify_code:'',
            apply_code:true,
            code_timing:60,
            timer:''
          }
        },
        created(){
          console.log(this.$store.state.bind_link_url)
        },
        methods:{
          submitfun(){
            let _this = this;
            if(this.verify_phone()){
              if(this.verify_code == ''){
                this.error = '验证码不能为空';
                this.isDialogShow = false;
                setTimeout(function(){
                  _this.isDialogShow = false;
                },2000);
              }else{
                this.$api.get("",{
                    api:"/v1/user/rela_mobile",
                    mobile:this.phone_num,
                    verify_code:this.verify_code,
                    user_type:this.tools.getStorage("user_type")
                  },
                  res => {
                    if(res.status == 1){
                      this.tools.setCookie('mooc_user_id',res.data.mooc_user_id,res.data.expire_time);
                      this.tools.setCookie('mooc_user_salt',res.data.salt,res.data.expire_time);
                      this.tools.setCookie('mooc_user_token',res.data.user_token,res.data.expire_time);
                      this.tools.setStorage('mooc_user_id',res.data.mooc_user_id,res.data.expire_time);
                      this.tools.setStorage('mooc_user_salt',res.data.salt,res.data.expire_time);
                      this.tools.setStorage('mooc_user_token',res.data.user_token,res.data.expire_time);
                      this.tools.setStorage('center_id',res.data.center_id,res.data.expire_time);
                      this.$store.commit("setbindphone",1);
                      // this.$store.commit("setLogin");
                      this.$router.replace(this.$store.state.bind_link_url);
                    }
                  })
              }
            }else{
              console.log('失败')
            }
          },
          send_code(){
            let _this = this;
            if(this.verify_phone()){
              if(this.apply_code){
                _this.code_timing = 60;
                this.apply_code = false;
                this.timer = setInterval(function(){
                  _this.code_timing--;
                  if(_this.code_timing == 0){
                    _this.apply_code = true;
                    clearInterval(_this.timer)
                  }
                },1000);
                this.$api.get("",{
                    api:"/v1/code/mobile",
                    mobile:this.phone_num,
                    type:'regist'
                  },
                  res => {
                    console.log(res.data)
                  })
              }
            }else{

            }
          },
          verify_phone(){
            let _this = this;
            this.error = '请输入正确的手机号';
            this.isDialogShow = !(/^[0-9]{11}$/.test(this.$refs.phone_ipt.value));
            if(this.isDialogShow){
              setTimeout(function(){
                _this.isDialogShow = false;
              },2000);
              return false
            }else{
              return true
            }
          }
        }
    }
</script>

<style scoped>
  .tip_b{ margin: 0 auto; width: 5.8rem; padding-top: 1.73rem; padding-bottom: .75rem;}
  .shield{ width: 1.33rem;}
  .tip_p{ font-size: .51rem; line-height: 1.6;}
  .phone_ipt{ display: block; margin: 0 auto; height:1.66rem; width: 92%; border:none; border-bottom: solid 1px #E6E6E6; font-size: .43rem;}
  .verify_code_b{ height:1.66rem; width: 92%; margin: 0 auto; border-bottom: solid 1px #E6E6E6;}
  .verify_code{ width: 56%; font-size: .43rem; height: 100%; border:none;}
  .verify_code_btn{ width: 44%; height: .9rem; margin-top: .38rem; line-height: .9rem; box-sizing: border-box; border-left: solid 1px #E6E6E6; font-size: .43rem; text-align: center; color: #EC6D3A;}
  .submit_btn{ width: 100%; height: 1.33rem; line-height: 1.33rem; background: #EC6D3A; position: fixed; bottom: 0; left: 0; text-align: center; color: #fff; font-size: .43rem;}
  .msg_pop{ background: rgba(0,0,0,0.6); color: #fff; padding: 10px 20px; border-radius: 8px; position: fixed; top: 50%; left: 50%; transform: translate(-50%,-50%);}

</style>



// WEBPACK FOOTER //
// src/components/bindphone/bindphone.vue